import React from 'react';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import ContainerBox from 'common/components/layout/ContainerBox';
import * as RentalViewSelectors from 'selectors/RentalViewSelectors';
import { useTranslation } from 'services/localization';
import { getResponsiblePersonDetails } from 'common/utils/newRentalUtils';
import DetailSection from './DetailSection';
import { notUndefined } from 'common/utils/common';

const ContactDetails = () => {
	const { t } = useTranslation();
	const shoppers = useSelector(RentalViewSelectors.orderShoppers);
	const orderInfo = useSelector(RentalViewSelectors.orderInfo)!;
	const responsiblePerson = getResponsiblePersonDetails(orderInfo.responsiblePerson, shoppers);
	const responsiblePersonName = [responsiblePerson.firstName, responsiblePerson.lastName]
		.filter(notUndefined)
		.join(' ');

	const contactDetailsItems = [
		{
			label: t('orderSummaryDialog.contactDetails.customer', 'Customer'),
			values: [responsiblePersonName, responsiblePerson.email, responsiblePerson.phone],
		},
	].filter((item) => notUndefined(item.values));

	return (
		<ContainerBox>
			<Typography mb={2} variant="h6">
				{t('orderSummaryDialog.contactDetails.header', 'Contact details')}
			</Typography>
			<DetailSection items={contactDetailsItems} />
		</ContainerBox>
	);
};

export default ContactDetails;
